<template>
  <div class="">
    <div class="wrapp__search" :class="[{'show--input':roles.includes('tutor') && togleTutor===false}]" >
      <div class="wrapp__search--input">
        <input 
        type="text" :placeholder="placeHolder" 
        @keyup.enter="search" v-model="query" >
      </div>
      <div class="wrapp__search--icon" @click="search">
        <i class="fa fa-search" aria-hidden="true"></i>
      </div>
    </div>
    <template v-for="(item, index) in navMenuItems">
      <template v-if="!item.hidden && roles.includes('tutor')">
        <VNavMenuItem
          :key="`item-${index}`"
          :icon="item.meta.icon"
          :to="item.path"
          :i18n="item.meta.i18n"
          :name="item.meta.name"
        />
      </template>
    </template>
     <template v-if="roles.includes('student')">
        <VNavMenuItem
          :key="0"
          :icon="newNavMenuItems[0].meta.icon"
          :to="newNavMenuItems[0].path"
          :i18n="newNavMenuItems[0].meta.i18n"
          :name="newNavMenuItems[0].meta.name"
        />
      </template>
       <template v-if="roles.includes('student')">
        <VNavMenuItem
          :key="1"
          :icon="newNavMenuItems[1].meta.icon"
          :to="newNavMenuItems[1].path"
          :i18n="newNavMenuItems[1].meta.i18n"
          :name="newNavMenuItems[1].meta.name"
        />
      </template>
       <template v-if="roles.includes('student')">
        <VNavMenuItem
          :key="2"
          :icon="newNavMenuItems[2].meta.icon"
          :to="newNavMenuItems[2].path"
          :i18n="newNavMenuItems[2].meta.i18n"
          :name="newNavMenuItems[2].meta.name"
        />
      </template>
     <template v-if="roles.includes('tutor')">
      <VNavMenuItem
              icon="tutor/Icon_menu_4.svg"
              to=""
              i18n="tutorialTutor"
              name="Tutorial for Tutor"
              @click.native="toggleTutorTutorial()"
            />
     </template>
    <template v-if="roles.includes('tutor')">
    <VNavMenuItem
            icon="tutor/Icon_menu_5.svg"
            to=""
            i18n="tutorialStudent"
            name="Tutorial for Student"
            @click.native="toggleStudentTutorial()"
          />
      </template>
  
    <template v-if="roles.includes('student')">
      <!--<VNavMenuItem
        icon="lupa.png"
        to=""
        i18n="search"
        name="Search lesson"
        @click.native="$store.commit('app/TOGGLE_DIALOG_LESSON_SEARCH_VISIBLE')"
      />-->
      <VNavMenuItem
        v-if="(authenticatedUser.grade_id !== 2 &&
          authenticatedUser.grade_id !== 5 &&
          authenticatedUser.grade_id !== 9 &&
          authenticatedUser.grade_id !== 55)"
        icon="laptop-computer.svg"
        to=""
        i18n="practices"
        name="practices"
        @call-link-practices="locationPractices"
      />
      </template>
      <template v-if="roles.includes('student')">
      <VNavMenuItem
              :class="[{'show-item': $route.params.lesson_id>0} ]" 
              icon="Boton_Worksheets.svg"
              to=""
              i18n="workSheets"
              name="Worksheets"
               @click.native="onWorksheets()"
            />
       </template>
        <template v-if="roles.includes('student')">
      <VNavMenuItem
        icon="language.png"
        to=""
        i18n="language"
        name="Language"
        @click.native="dialogLanguageVisible = true"
      />
    </template>
    <template v-if="roles.includes('student')"> 
        <VNavMenuItem
          :key="3"
          :icon="newNavMenuItems[3].meta.icon"
          :to="newNavMenuItems[3].path"
          :i18n="newNavMenuItems[3].meta.i18n"
          :name="newNavMenuItems[3].meta.name"
        />
    </template>
    <VNavMenuItem v-if="roles.includes('tutor')" icon="tutor/Icon_menu_logout.svg" to="" i18n="signOut" name="SignOut" @click.native="selectTemplate" />
    <VNavMenuItem v-else="" icon="logout.png" to="" i18n="signOut" name="SignOut" @click.native="selectTemplate" />
    <div v-if="dialogSignOutVisible" class="sign-out">
      <TemplateOne v-if="useTemplate === 0" @exit="onLogout"></TemplateOne>
      <TemplateTwo v-if="useTemplate === 1" @exit="onLogout"></TemplateTwo>
      <TemplateThree v-if="useTemplate === 2" @exit="onLogout"></TemplateThree>
    </div>

    <LanguageSelector :visible="dialogLanguageVisible" @close="dialogLanguageVisible = false" />
       <tpm-modal :showhide="showTutorTutorial">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleTutorTutorial">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <iframe
          v-if="showTutorTutorial && $store.state.language === 'en' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && $store.state.language === 'es' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && lang === 'en' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showTutorTutorial && lang === 'es' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaTutorEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>

        <div class="message-expand">
          <div class="body-message">
            <p>
              {{ $t('help.chooseVideo') }}
              <img src="@/assets/icons/expand-window.gif" />
              {{ $t('help.expandIcon') }}
            </p>
          </div>
        </div>
      </div>
    </tpm-modal>
        <tpm-modal :showhide="showStudentTutorial">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleStudentTutorial">
          <img src="@/assets/icons/menu/windows_control/Close_1.svg" class alt="Close" />
        </button>
      </div>
      <div class="modal-body">
        <iframe
          v-if="showStudentTutorial && $store.state.language === 'en' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && $store.state.language === 'es' && !roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && lang === 'en' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEn/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>
        <iframe
          v-if="showStudentTutorial && lang === 'es' && roles.includes('student')"
          class="tutorial"
          src="static/help/TutorialParaEstudianteEsp/index.html"
          frameborder="0"
          allowfullscreen
        ></iframe>

        <div class="message-expand">
          <div class="body-message">
            <p>
              {{ $t('help.chooseVideo') }}
              <img src="@/assets/icons/expand-window.gif" />
              {{ $t('help.expandIcon') }}
            </p>
          </div>
        </div>
      </div>
    </tpm-modal>
       
    <el-dialog
      v-loading="loading"
      title="Worksheets"
      :visible.sync="dialogVisible"
      top="3vh"
      width="90%"
      :before-close="handleClose"
    >
      <div class="row">
        <template v-if="listUrlWorksheet.length === 0">
          <div class="col-12">
            <h1 class="mt-5 text-center">{{ $t('worksheets.notFound') }}</h1>
          </div>
        </template>
        <template v-else>
          <div
            v-for="link in listUrlWorksheet"
            :key="link"
            :class="listUrlWorksheet.length === 1 ? 'col-12' : 'col-sm-12 col-md-6'"
          >
            <iframe
              :src="link"
              width="100%"
              class="worksheets-iframe"
              @load="
                () => {
                  loading = false;
                }
              "
            ></iframe>
            <!-- <pdf :ref="`pdf${index}`" :src="link" class="worksheets-iframe" @page-loaded="loading = false"></pdf> -->
          </div>
        </template>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import VNavMenuItem from './VerticalNavMenuItem.vue';
import { mapGetters, mapActions } from 'vuex';
import TemplateOne from './components/TemplateOne';
import TemplateTwo from './components/TemplateTwo.vue';
import TemplateThree from './components/TemplateThree.vue';
import LanguageSelector from './components/LanguageSelector.vue';
import swal from 'sweetalert';
import i18n from "@/i18n/i18n";

export default {
  name: 'VerticalNavMenu',
  components: {
    VNavMenuItem,
    TemplateOne,
    TemplateTwo,
    TemplateThree,
    LanguageSelector,
  },
  props: {
    navMenuItems: { type: Array, required: true },
  },
  data() {
    return {
      dialogLanguageVisible: false,
      dialogSignOutVisible: false,
      useTemplate: null,
      // loginAccessToken: null,
      placeHolder:'',
      query:'',
      question:'',
            showTutorTutorial: false,
            showStudentTutorial: false,
      newNavMenuItems:[],
       loading: false,
       listUrlWorksheet: [],
       dialogVisible: false,
       hostname: window.location.hostname,
    };
  },
  computed: {
    ...mapGetters({
      roles: 'auth/roles',
      authenticatedUser: 'auth/authenticatedUser',
      accessToken: 'auth/accessToken',
      lang: 'app/language',
      sidebar:'app/sidebar',
      togleTutor:'app/togleTutor',
      currentLesson: 'lesson/currentLesson',
    }),
  },
  created() {
    this.placeHolder=i18n.t("search");
    // Assign received access token
    // this.loginAccessToken = this.$route.params.access_token;
    if(this.roles[0]==='tutor'){
      //console.log('is tutor');
      this.sidebar.isCollapsed=false;
    }else{
      //console.log('is student');
    }
    // nuevo arreglo para mostrar items de menu por orden de importancia
    this.navMenuItems.forEach(el=>{
      if(!el.hidden){
        if(el.name==='home'){
          el['order'] = 1;
        }
        if(el.name==='spelling-helper-dictionary'){
          el['order'] = 2;
        }
        if(el.name==='book'){
          el['order'] = 3;
        }
        if(el.name==='help'){
          el['order'] = 6;
        }
        this.newNavMenuItems.push(el);
      }
    })
        console.log(this.newNavMenuItems);
        this.newNavMenuItems.push({

        })
    
  },
  methods: {
    selectTemplate() {
      if (
        (this.authenticatedUser.grade_id === 9 ||
          this.authenticatedUser.grade_id === 55 ||
          this.authenticatedUser.grade_id === 109 ||
          this.authenticatedUser.grade_id === 157 ||
          this.authenticatedUser.grade_id === 200 ||
          this.authenticatedUser.grade_id === 2 ||
          this.authenticatedUser.grade_id === 5) &&
        this.roles.includes('student')
      ) {
        this.useTemplate = Math.round(Math.random() * 2);
        this.dialogSignOutVisible = true;
      } else {
        swal({
          title: this.$t('messages.areYouSure'),
          text: this.$t('messages.endSession'),
          icon: 'warning',
          buttons: [this.$t('messages.no'), this.$t('messages.yes')],
          closeOnClickOutside: false,
        }).then(signout => {
          if (signout) {
            this.onLogout(true);
            // this.saveSessionTime();
            // this.$activity.$emit('end-session');
          }
        });
      }
    },
    onLogout(value) {
      if (value === true) {
       this.sidebar.isCollapsed=true;
        this.logout().then(() => {
          location.reload();
        });
      } else {
        this.dialogSignOutVisible = false;
      }
    },
    locationPractices() {
      window.location.href = `http://state-exams.mytpm.org/tpmLogin/${this.accessToken}`;
    },
    ...mapActions({
      logout: 'auth/AUTH_LOGOUT',
    }),
    getPlaceHolder(){
      if(this.lang==='en'){
        return i18n.t("search")
      }else{
        return i18n.t("search")
      }
    },
    search(){
      if(this.query.length>1){
        this.$store.commit('app/SET_CURRENT_QUERY', this.query);
        this.$store.commit('app/TOGGLE_DIALOG_LESSON_SEARCH_VISIBLE');

      }else{
        swal({
           text: i18n.t("whatSearch"),
          icon: 'warning',
          buttons:"ok",
          dangerMode: true,
        })
      }
    },
 toggleTutorTutorial() {
  console.log("Tutor tutorial" );
      this.setLargeModal();
      this.showTutorTutorial = !this.showTutorTutorial;
      /*this.tutorialsView = !this.tutorialsView;*/
    },
    toggleStudentTutorial() {
      console.log("Student tutorial" );
      this.setLargeModal();
      this.showStudentTutorial = !this.showStudentTutorial;
      /*this.tutorialsView = !this.tutorialsView;*/
    },
    setLargeModal() {
      var payload = {
        width: '100',
        prefixWidth: 'vw',
        height: '90',
        prefixHeight: 'vh',
      };
      this.$store.commit('SET_STYLE_MODAL', payload);
    },
    onWorksheets(){
        this.loading = true;
      this.listUrlWorksheet = [];
      this.dialogVisible = true;
      let files = [
        { name: this.currentLesson.id + '.pdf' },
        { name: this.currentLesson.id + '_1.pdf' },
        { name: this.currentLesson.id + '_2.pdf' },
      ];
      files.forEach(file => {
        let imageUrl = 'https://' + this.hostname + '/static/worHud98Km/' + file.name;
        var http = new XMLHttpRequest();
        http.open('HEAD', imageUrl, false);
        http.send();
        if (http.status != 404) {
          this.listUrlWorksheet.push(imageUrl);
        }
      });

      // en caso de que no exiatan worksheets
      this.listUrlWorksheet.length ? null : (this.loading = false);
    },
  },
  watch: {
    lang(val1, val2){
      this.placeHolder=i18n.t("search");
    }
  }
};
</script>

<style lang="scss" scoped>
$color-text-blue: #3960A5;
.wrapp__search{
  width: 100;
  text-align: center;
  display: grid;
  grid-template-columns: 70% 30%;
  padding: 1rem 0.5rem;
  align-items: center;
  &--input{
    margin-left: 10px;
    border-radius: 10px;
    overflow: hidden;
    input{
      border: none;
      padding: 0 1rem;
      line-height: 3rem;
      background-color: white;
    }
 
  }
  &--icon{
    height: 2rem;
    width: 2rem;
    border-radius: 1rem;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 1rem;
    cursor: pointer;
    i{
      font-size: 1.1rem;
      color: $color-text-blue;
    }
  }
}
   .show--input{
      display: none;
    }
.modal-header {
  background-color: #cdd528;
  border: none;
  .close {
    position: absolute;
    top: 0px;
    right: 20px;
    opacity: 1;
    img {
      width: 30px;
    }
    &:focus {
      outline: none;
    }
  }
}
.modal-body {
  height: 100%;
  padding: 0;
  border-left: 5px solid #cdd528;
  border-right: 5px solid #cdd528;
  border-bottom: 25px solid #cdd528;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  line-height: 22px;
  overflow-y: scroll;
}
.logo-hmp {
  text-align: center;
  img {
    padding: 10px;
    height: 150px;
  }
}
.header {
  display: inline-block;
  width: auto;
  height: 50px;
  padding: 14px 20px 0;
  color: #fff;
  font-family: 'comfortaabold';
  font-size: 26px;
  background-color: #cdd528;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  img {
    margin-top: -8px;
    margin-right: 10px;
    height: 34px;
    vertical-align: middle;
  }
}
.contact-info {
  padding: 20px;
  color: #4ea8b4;
  font-size: 20px;
  p {
    margin-bottom: 10px;
  }
}
.manual-links {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: #000;
    label {
      margin: 0;
      padding-bottom: 0.5rem;
      font-family: 'comfortaabold';
      cursor: pointer;
    }
    img {
      cursor: pointer;
    }
  }
}
.tutorial {
  width: 100%;
  height: 100%;
}

//landscape phone
@media (max-height: 350px) {
  .tutorial {
    height: 70%;
  }
}
@media (max-width: 576px) {
  .modal-body {
    height: unset;
  }
}
@include forTablet() {
  .items {
    display: flex;
  }
  .modal-body {
    height: unset;
  }
}
@include forDesktop() {
  .help .center {
    width: 50%;
  }
}

.message-expand {
  width: 100%;
  height: auto;
  font-size: 20px;
  margin-bottom: 20px;
}

.message-expand > .body-message {
  text-align: center;
}

.message-expand > .body-message > p > img {
  max-width: 30px;
  vertical-align: bottom;
}
</style>
